import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashedLines = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 2,
	height: 21,
	viewBox: "0 0 2 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("line", {
		x1: .75,
		y1: 21,
		x2: .75,
		stroke: "url(#paint0_linear_3006_11880)",
		strokeWidth: 1.5,
		strokeDasharray: "4 4"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_3006_11880",
		x1: 2,
		y1: 0,
		x2: 2,
		y2: 21,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFD36C" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#FBB243"
		})]
	}) })]
});
export default SvgDashedLines;
